import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { urls, strings } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { ICheckStatus, IConfirmEmail } from './recuperar-senha.interface';
import { ICreatePassword, INewPassword } from '../../../../modules/auth/components/register-password/register-password.interface';

@Injectable()
export class RecuperarSenhaService {
  headers: HttpHeaders;
  localStorageService: any;
  constructor(private http: HttpClient) { }

  addHeaders() {
    this.headers = new HttpHeaders();
    const loginObject = this.localStorageService.get('login');
    this.headers = this.headers.set('Authorization', 'Bearer ' + loginObject.Token);
  }

  enviaRecuperarSenha(email: string) {
    const data = { Email: email, Module: 'PagueLa', Account: strings.pagueLaAccount };
    return this.http
      .post(urls.apiBaseActuar + '/accounts/SendPasswordResetToken', data);
  }

  enviarEmailParaRedefinicaoDeSenha(data: any) {
    return this.http
      .put(urls.apiBaseActuar + '/Contas/EnviarEmailParaRedefinicaoDeSenha', data);
  }

  redefinirSenha(data: any) {
    return this.http
      .put(`${urls.apiBaseActuar}/Contas/RedefinirSenha`, data);
  }

  public checkStatus(email): Observable<ICheckStatus> {
    return this.http
      .get(`${urls.user_service}/Auth/CheckStatus?email=${email}`, {
        withCredentials: false
      });
  }

  public sendEmailResetPassword(email: string): Observable<Object> {
    return this.http
      .post(`${urls.user_service}/Auth/SendEmailResetPassword`, { Email: email }, {
        withCredentials: false
      });
  }

  public confirmEmail(form: IConfirmEmail): Observable<Object> {
    return this.http
    .post(`${urls.user_service}/Auth/ConfirmEmail`, form, {
      withCredentials: false
    })
  }

  public checkResetPassowrd(form: IConfirmEmail): Observable<Object> {
    return this.http
    .post(`${urls.user_service}/Auth/CheckResetPasswordCode`, form, {
      withCredentials: false
    })
  }

  public createPassword(formCreatePassword: ICreatePassword): Observable<Object> {
    return this.http
      .post(`${urls.user_service}/Auth/CreatePassword`, formCreatePassword, {
        withCredentials: false
      });
  }

  public resetPassword(form: INewPassword): Observable<Object> {
    return this.http
      .post(`${urls.user_service}/Auth/ResetPassword`, form, {
        withCredentials: false
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/recuperar-senha/recuperar-senha.service.ts